export const LANE = 'LANE';
export const NOTE = 'NOTE';



/** WEBPACK FOOTER **
 ** ./src/kanban2/constants/itemTypes.js
 **/